var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sv_02 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9999 4.00024H17.9999C7.99989 4.00024 3.99988 8.00024 3.99988 18.0003V30.0003C3.99988 40.0002 7.99989 44.0002 17.9999 44.0002H29.9999C40 44.0002 43.9999 40.0002 43.9999 30.0003V26.0002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.0801 6.04027L16.3202 21.8003C15.7202 22.4003 15.1202 23.5802 15.0002 24.4403L14.1401 30.4602C13.8201 32.6402 15.3602 34.1603 17.5401 33.8603L23.5601 33.0002C24.4001 32.8802 25.5801 32.2802 26.2001 31.6802L41.9601 15.9203C44.6801 13.2003 45.9602 10.0403 41.9601 6.04027C37.9601 2.04026 34.8002 3.32026 32.0801 6.04027Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M29.8201 8.30029C31.16 13.0803 34.9001 16.8203 39.7001 18.1803",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualBranding);
export default __webpack_public_path__ + "static/media/visual-branding.6ea4d9458d8c008f96aeba6b04629326.svg";
export { ForwardRef as ReactComponent };